import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { supabase } from '@/src/lib/supabase';

export type PushStatus = 'unsupported' | 'granted' | 'denied' | 'prompt';
let listenersAdded = false;

async function saveToken(token: string) {
  const { error } = await supabase.rpc('register_device_token', { p_token: token, p_platform: 'ios' });
  if (error) console.warn('push: could not save device token', error.message);
}

function addListeners() {
  if (listenersAdded) return;
  listenersAdded = true;
  void PushNotifications.addListener('registration', (t) => { void saveToken(t.value); });
  void PushNotifications.addListener('registrationError', (e) => console.warn('push: registration failed', e.error));
  // Tapping a notification: open the screen it points to (e.g. tasks, training).
  void PushNotifications.addListener('pushNotificationActionPerformed', (a) => {
    const data = a.notification.data as { drawer?: string; channel_id?: string } | undefined;
    const drawer = data?.drawer;
    // Team Chats: open that conversation.
    if (data?.channel_id) { try { localStorage.setItem('opsalo:team-open', data.channel_id); } catch { /* ignore */ } }
    if (drawer) window.dispatchEvent(new CustomEvent('opsalo:open-drawer', { detail: drawer }));
  });
}

export async function pushStatus(): Promise<PushStatus> {
  if (!Capacitor.isNativePlatform()) return 'unsupported';
  const p = await PushNotifications.checkPermissions();
  if (p.receive === 'granted') return 'granted';
  if (p.receive === 'denied') return 'denied';
  return 'prompt';
}

/** Call once when signed in: re-registers silently if permission was already given. */
export async function initPush() {
  if (!Capacitor.isNativePlatform()) return;
  addListeners();
  if ((await pushStatus()) === 'granted') await PushNotifications.register();
}

/** Shows Apple's permission popup; registers if allowed. */
export async function enablePush(): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) return false;
  addListeners();
  const p = await PushNotifications.requestPermissions();
  if (p.receive !== 'granted') return false;
  await PushNotifications.register();
  return true;
}